/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrderStakeholderQuery } from '../../models/get-order-stakeholder-query';
import { GetOrderStakeholderQueryResult } from '../../models/get-order-stakeholder-query-result';

export interface ApiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Params {
      body?: GetOrderStakeholderQuery
}

export function apiNurseryManagerOrderStakeholderGetOrderStakeholderPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderStakeholderGetOrderStakeholderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderStakeholderQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderStakeholderGetOrderStakeholderPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrderStakeholderQueryResult>;
    })
  );
}

apiNurseryManagerOrderStakeholderGetOrderStakeholderPost.PATH = '/api/NurseryManager/OrderStakeholder/GetOrderStakeholder';
